import SlsTracker from '@aliyun-sls/web-track-browser';
import { SLS_LOGIN_TYPE } from '../common';
import { getOS, getBrowser, AuthStorage } from '@/common/utils';

const { VUE_APP_ALIYUN_LOG_HOST, VUE_APP_ALIYUN_LOG_PROJECT, VUE_APP_ALIYUN_LOG_LOGSTORE } = process.env;

const tracker = new SlsTracker({
  host: VUE_APP_ALIYUN_LOG_HOST || '',
  project: VUE_APP_ALIYUN_LOG_PROJECT || '',
  logstore: VUE_APP_ALIYUN_LOG_LOGSTORE || '',
});

// 初始化参数
const searchParams = new URLSearchParams(window.location.search);
const sls_keys = [
  'eventSessionId',
  'sdk_version',
  'event_index_web',
  'brand',
  'channel',
  'device_id',
  'app_version',
  'login_type',
  'sub_login_type',
  'xd_client_id',
  'os',
  'os_version',
  'language',
  'lang',
  'console_type',
  'isloginmodule',
  'loc',
  'model',
  'orientation',
  'session_uuid',
  'ip',
];
for (const [key, value] of searchParams) {
  if (sls_keys.includes(key)) {
    AuthStorage.set('sls_' + key, value);
  }
}

// event_index_web
let event_index_web = Number(searchParams.get('event_index_web') || AuthStorage.get('sls_event_index_web') || 0);

export const sls_send = (name, payload, type = 'sendImmediate') => {
  try {
    // ['send', 'sendImmediate', 'sendBatchLogs', 'sendBatchLogsImmediate']
    if (!tracker[type]) {
      console.error('ERROR:: sls_send 埋点方法不存在');
      return;
    }
    const searchParams = new URLSearchParams(window.location.search);
    // eventSessionId： SDK 登录从url上获取，其他从 sessionStorage 获取
    const eventSessionId =
      searchParams.get('eventSessionId') || searchParams.get('eventId') || AuthStorage.get('sls_eventSessionId');
    if (!eventSessionId) {
      console.error('ERROR:: sls_send eventSessionId 不存在');
    } else {
      AuthStorage.set('sls_eventSessionId', eventSessionId);
    }
    const browser = getBrowser();
    // 基础参数
    const base = {
      tag: 'sdklogin',
      time: new Date().valueOf(),
      name,
      source: 'Web',
      event_session_id: eventSessionId,
      logid: eventSessionId + name + new Date().valueOf(),
      event_index_web: event_index_web++,
      sdk_version:
        searchParams.get('sdk_version') ||
        searchParams.get('xd_js_sdk_auth_version') ||
        AuthStorage.get('sls_sdk_version') ||
        '',
      brand: searchParams.get('brand') || AuthStorage.get('sls_brand') || browser.version || '',
      channel: searchParams.get('channel') || AuthStorage.get('sls_channel') || '',
      device_id: searchParams.get('device_id') || AuthStorage.get('sls_device_id') || '',
      app_version: searchParams.get('app_version') || AuthStorage.get('sls_app_version') || '',
      login_type: searchParams.get('login_type') || AuthStorage.get('sls_login_type') || '',
      user_login_type: searchParams.get('login_type') || AuthStorage.get('sls_login_type') || '',
      sub_login_type: searchParams.get('sub_login_type') || AuthStorage.get('sls_sub_login_type') || '',
      xd_client_id: searchParams.get('xd_client_id') || AuthStorage.get('sls_xd_client_id') || '',
      os: searchParams.get('os') || AuthStorage.get('sls_os') || getOS().name || '',
      os_version: searchParams.get('os_version') || AuthStorage.get('sls_os_version') || getOS().version || '',
      language: searchParams.get('language') || AuthStorage.get('sls_language') || window.navigator.language || '',
      lang: searchParams.get('lang') || AuthStorage.get('sls_lang') || '',
      console_type: searchParams.get('console_type') || AuthStorage.get('sls_console_type') || '',
      user_from: AuthStorage.get('sls_redirect_uri') || window.location.href || '',
      loc: searchParams.get('loc') || AuthStorage.get('sls_loc') || '',
      model: searchParams.get('model') || AuthStorage.get('sls_model') || browser.name || '',
      orientation: searchParams.get('orientation') || AuthStorage.get('sls_orientation') || '',
      session_uuid: searchParams.get('session_uuid') || AuthStorage.get('sls_session_uuid') || '',
    };
    AuthStorage.set('event_index_web', String(event_index_web));
    const ip = searchParams.get('ip');
    ip && (base.ip = ip);
    const isloginmodule = searchParams.get('isloginmodule') || AuthStorage.get('sls_isloginmodule') || '';
    if (isloginmodule) {
      base.isloginmodule = isloginmodule === 'True' ? 'true' : isloginmodule;
    }
    // 上报埋点
    tracker[type]({
      content: {
        ...base,
        ...payload,
      },
    });
  } catch (error) {
    console.error('ERROR:: sls_send', error);
  }
};

/* 手机登录发送验证码成功 */
export function sls_send_code_send_success() {
  let event_times = sessionStorage.getItem('sdklogin_mobile_code_send_success_event_times') || 0;
  sls_send('sdklogin_mobile_code_send_success', {
    event_times: event_times++,
    sub_login_type: 'text',
  });
  sessionStorage.setItem('sdklogin_mobile_code_send_success_event_times', event_times);
}
/* 手机登录发送验证码失败 */
export function sls_send_code_send_fail(smsCode) {
  let event_times = sessionStorage.getItem('sdklogin_mobile_code_send_fail_event_times') || 0;
  sls_send('sdklogin_mobile_code_send_fail', {
    event_times: event_times++,
    event_reason: smsCode,
    sub_login_type: 'text',
  });
  sessionStorage.setItem('sdklogin_mobile_code_send_fail_event_times', event_times);
}
/* 输入验证码 */
export function sls_send_sdklogin_mobile_code_input() {
  let event_times = sessionStorage.getItem('sdklogin_mobile_code_input_event_times') || 0;
  sls_send('sdklogin_mobile_code_input', { event_times: event_times++ });
  sessionStorage.setItem('sdklogin_mobile_code_input_event_times', event_times);
}

/* 手机登录验证码校验通过 */
export function sls_send_code_success() {
  let event_times = sessionStorage.getItem('sdklogin_mobile_code_success_event_times') || 0;
  sls_send('sdklogin_mobile_code_success', {
    event_times: event_times++,
    sub_login_type: 'text',
  });
  sessionStorage.setItem('sdklogin_mobile_code_success_event_times', event_times);
}
/* 手机登录验证码校验失败 */
export function sls_send_code_fail(event_reason) {
  let event_times = sessionStorage.getItem('sdklogin_mobile_code_fail_event_times') || 0;
  sls_send('sdklogin_mobile_code_fail', {
    event_times: event_times++,
    event_reason,
    sub_login_type: 'text',
  });
  sessionStorage.setItem('sdklogin_mobile_code_fail_event_times', event_times);
}

/* 登录风控拦截成功 */
export function sls_send_sdklogin_risk_success(event_reason, sub_login_type) {
  sls_send('sdklogin_risk_success', { event_reason, sub_login_type });
}

/* 跳转授权	 */
export function sls_send_sdklogin_to_authorize(login_type) {
  AuthStorage.set('sls_login_type', login_type);
  const payload = { login_type };
  if (login_type === SLS_LOGIN_TYPE.phone) {
    payload.sub_login_type = 'text';
  }
  sls_send('sdklogin_to_authorize', payload);
}

/* 跳转授权成功 */
export function sls_send_sdklogin_authorize_success(login_type) {
  sls_send('sdklogin_authorize_success', { login_type, user_login_type: login_type });
}

/* 授权失败 */
export function sls_send_sdklogin_authorize_fail(event_reason) {
  sls_send('sdklogin_authorize_fail', { event_reason });
}

/* 跳转到手机登录页面 */
export function sls_send_sdklogin_to_mobile_define() {
  sls_send('sdklogin_to_mobile_define', {
    enter_from: 'start',
    sub_login_type: 'text',
  });
}

/* 在输入手机号页面点击按钮	 */
export function sls_send_sdklogin_mobile_button_click(button_click) {
  sls_send('sdklogin_mobile_button_click', {
    button_click,
    sub_login_type: 'text',
  });
}

/* SDK登录失败 */
export function sls_send_sdklogin_pre_login_fail(event_reason) {
  sls_send('sdklogin_pre_login_fail', { event_reason });
}
/* SDK登录成功 */
export function sls_send_sdklogin_pre_login_success(login_type) {
  sls_send('sdklogin_pre_login_success', { login_type });
}

/* 唤起暂停手机号注册弹窗 */
export function sls_send_sdklogin_mobile_block() {
  sls_send('sdklogin_mobile_block', { login_type: SLS_LOGIN_TYPE.phone });
}

/* 暂停手机号注册页面点击按钮 */
export function sls_send_sdklogin_mobile_block_button_click(type) {
  sls_send('sdklogin_mobile_block_button_click', { login_type: SLS_LOGIN_TYPE.phone, button_click: type });
}

export default {
  sdklogin_mobile_code_send_success: sls_send_code_send_success,
  sdklogin_mobile_code_send_fail: sls_send_code_send_fail,
  sdklogin_mobile_code_success: sls_send_code_success,
  sdklogin_mobile_code_fail: sls_send_code_fail,
  sdklogin_mobile_code_input: sls_send_sdklogin_mobile_code_input,
  sdklogin_risk_success: sls_send_sdklogin_risk_success,
  sdklogin_to_authorize: sls_send_sdklogin_to_authorize,
  sdklogin_authorize_success: sls_send_sdklogin_authorize_success,
  sdklogin_authorize_fail: sls_send_sdklogin_authorize_fail,
  sdklogin_to_mobile_define: sls_send_sdklogin_to_mobile_define,
  sdklogin_mobile_button_click: sls_send_sdklogin_mobile_button_click,
  sdklogin_pre_login_fail: sls_send_sdklogin_pre_login_fail,
  sdklogin_pre_login_success: sls_send_sdklogin_pre_login_success,
  sdklogin_mobile_block: sls_send_sdklogin_mobile_block,
  sdklogin_mobile_block_button_click: sls_send_sdklogin_mobile_block_button_click,
};
